import axios, { AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import { baseUrl } from '../constatnts/Connections';
import { handleSuccess, handleError } from './server';
import { KategorijaNovaDto, KategorijaUpdateDto } from '../model/kategorijaDto';
import { PodkategorijaNovaDto, PodkategorijaUpdateDto } from '../model/podkategorijaDto';
import { SkupOblastiNovaDto, SkupOblastiUpdateDto } from '../model/skupOblasti';
import { OblastNovaDto, OblastUpdateDto } from '../model/oblastDto';
import { PodoblastNovaDto, PodoblastUpdateDto } from '../model/podoblastDto';
import { LekcijaNovaDto } from '../model/lekcijaDto';

export async function getKategorije() {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/kategorija/all`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}

export async function getKategorijeVisible() {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/kategorija/visible/all`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}

export async function createNewKategorija(data: KategorijaNovaDto) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/kategorija/nova`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function updateNewKategorija(data: KategorijaUpdateDto) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/kategorije/update`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function updateListeKategorija(data: any) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/kategorije/update`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
// -------------------------------------------potkategorije-----------------------------------
export async function getPodkategorije() {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/podkategorija/all`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function getPodkategorijeVisible() {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/podkategorija/visible/all`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function getPodkategorijeByKategorijaId(id: string | undefined) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/podkategorija/all/${id}`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function createNewPodkategorija(data: PodkategorijaNovaDto) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/podkategorija/nova`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function updateNewPodkategorija(data: PodkategorijaUpdateDto) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/podkategorija/update`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function updateListePodkategorija(data: any) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/podkategorije/update`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function getSkupoviOblasti() {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/skup-oblasti/all`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function getSkupoviOblastiVisible() {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/skup-oblasti/visible/all`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function getSkupOblastiByPodkategorijaId(id: string | undefined) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/skup-oblasti/all/${id}`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function createNewSkupOblasti(data: SkupOblastiNovaDto) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/skup-oblasti/nova`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function updateNewSkupOblasti(data: SkupOblastiUpdateDto) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/skup-oblasti/update`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function updateListeSkupOblasti(data: any) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/skupovi-oblasti/update`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function getOblasti() {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/oblast/all`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function createNewOblast(data: OblastNovaDto) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/oblast/nova`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function changeOblast(data: OblastUpdateDto) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/oblast/update`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function getVisibleOblastiBySkupOblastiId(id: string | undefined) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/oblast/visible/all/${id}`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function getOblastById(id: string | undefined) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/oblast/${id}`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function getOblastByIdAndVisiblePodoblast(id: string | undefined) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/oblast/visible-podoblast/${id}`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function deletePodoblastById(id: string | undefined) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/podoblast/${id}`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function getPodoblastiByOblastId(id: string | undefined) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/podoblast/all/${id}`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function getLekcijeAndPitanjaByPodoblastId(id: string | undefined) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/lekcija/all/${id}`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function getPitanjaByLekcijaId(id: string | undefined) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/pitanje/all/lekcija/${id}`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function getKvizPitanjaByLekcijaId(id: string | undefined) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/kviz-pitanje/all/lekcija/${id}`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function getKvizPitanjaForLekcijaByLekcijaId(id: string | undefined) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/kviz-pitanje/for-lekcija/lekcija/${id}`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function createNewPodoblast(data: PodoblastNovaDto) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/podoblast/nova`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function updateNewPodoblast(data: PodoblastUpdateDto) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/podoblast/update`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function createNewLekcija(data: any) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/lekcija/nova`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}

export async function updateNewLekcija(data: any) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/lekcija/update`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}

export async function createNewPitanje(data: any) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/pitanje/nova`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function createNewKvizPitanje(data: any) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/kviz-pitanje/nova`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}

export async function updateListePitanja(data: any) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/pitanja/update`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}

export async function updateListeKvizPitanja(data: any) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/kviz-pitanja/update`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}

export async function deletePitanjeById(id: string | undefined) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/pitanje/${id}`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function deleteKvizPitanjeById(id: string | undefined) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/kviz-pitanje/${id}`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}

export async function deleteKategorijaById(id: string | undefined) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/kategorija/${id}`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function getPitanjeById(id: string | undefined) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/pitanje/${id}`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function getKvizPitanjeById(id: string | undefined) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/kviz-pitanje/${id}`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function editPitanje(data: any) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/pitanje/update`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function editKvizPitanje(data: any) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/kviz-pitanje/update`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function getLekcijaById(id: string | undefined) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/lekcija/${id}`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}

export async function getPodoblastById(id: string | undefined) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/podoblast/${id}`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function getSkupOblastiById(id: string | undefined) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/skup-oblasti/${id}`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function getPodkategorijaById(id: string | undefined) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/podkategorija/${id}`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}

export async function getKategorijaById(id: string | undefined) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/kategorija/${id}`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
